import React, { useState } from 'react';
import { Upload as AntdUpload, message } from "antd";
import { useModal } from "@/store"
import { isFunction } from '@/check';
import { getBase64Sync } from '@/utils';

/**
 * 在 Antd Upload 组件基础上封装的上传组件
 * @param {*} props 
 */
function Upload(props) {

    const [loading, setLoading] = useState(false);
    const [cropperModal] = useModal(["cropper"]);
    const { maxSize, children, onFinish, cut = false } = props;

    async function beforeUpload(file) {
        const isLtMax = !maxSize || file.size / 1024 < maxSize;
        if (!isLtMax) {
            message.error(`图片必须小于 ${maxSize < 1024 ? maxSize + "kb" : maxSize / 1024 + "M"}`);
        }
        const res = isLtMax
        if (res) setLoading(true);

        if (cut) {
            file.width = 300;
            cropperModal.show({img: await getBase64Sync(file)})
        }

        return false;
    }

    const onChnageHandler = info => {
        if (info.file.status === 'done') {
            if (onFinish) onFinish(info)
            setLoading(false);
        }
    }

    return (
        <AntdUpload
            {...props}
            beforeUpload={beforeUpload}
            onChange={onChnageHandler}>
            {isFunction(children) ? children(loading) : children}
        </AntdUpload>
    )
}
export default Upload;